import React, { useEffect, useState } from "react";
import { Button, Select, Table, Tag, Tooltip } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import POTemplate from "../../PurchaseOrder/POTemplate";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

export default function POList({ tabChange }) {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const TIMEZONE = "Asia/Dhaka";

  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [supplierList, setSupplierList] = useState([]);
  const [poList, setPoList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [visibility, setVisibility] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [poLoading, setPoLoading] = useState(false);
  const [isView, setIsView] = useState(false);
  const [selectedPoData, setSelectedPoData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const handlePODateRage = (value) => {
    setCurrentPage(1);
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      // Convert to timezone first if needed
      let startDate = dayjs.tz(value[0], TIMEZONE).startOf("day");
      let endDate = dayjs.tz(value[1], TIMEZONE).endOf("day");

      // Convert to ISO string (UTC with Z)
      const formattedStartDate = startDate.toISOString();
      const formattedEndDate = endDate.toISOString();

      setSelectedDateRange([formattedStartDate, formattedEndDate]);
    } else {
      setSelectedDateRange(null);
    }
  };

  const handleSupplier = (value) => {
    setCurrentPage(1);
    setSelectedSupplier(value);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePoModalClose = () => {
    setVisibility(false);
    setIsView(false);
    setSelectedPoData(null);
  };

  const handlePoModalVisibility = (record) => {
    setVisibility(true);
    setSelectedPoData(record);
  };

  const fetchPoList = () => {
    setPoLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/po_list/`, {
        headers: authHeader(),
        params: {
          supplier_id: selectedSupplier,
          dateRange: selectedDateRange,
          page: currentPage,
          status: selectedStatus,
        },
      })
      .then((response) => {
        setPoLoading(false);
        setPoList(response?.data?.results);
        setTotalItems(response?.data?.count);
      })
      .catch((error) => {
        setPoLoading(false);
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  useEffect(() => {
    fetchPoList();
  }, [
    currentPage,
    selectedSupplier,
    selectedDateRange,
    selectedStatus,
    tabChange,
  ]);

  useEffect(() => {
    setPoLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/supplier_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setPoLoading(false);
        setSupplierList(response?.data);
      })
      .catch((error) => {
        setPoLoading(true);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const poColumn = [
    {
      title: "Date",
      render: (record) => record?.po_date,
      width: "6%",
    },
    {
      title: "PO ID",
      dataIndex: "po_id",
      width: "6%",
    },
    {
      title: "Supplier Name",
      render: (record) => record?.supplier_name,
      width: "10%",
    },
    {
      title: <div className="d-flex justify-content-center">Product & Quantity</div>,
      render: (record) =>
        record?.item_details?.map((item) => (
          <div
            key={item?.po_item_id}
            className="d-flex justify-content-between align-items-center px-3 py-2 mb-2 rounded"
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #e0e0e0",
            }}
          >
            <div className="fw-medium text-dark">
              {item?.product?.product_name}
            </div>

            <div className="text-dark">
              <span className="fw-semibold">{item?.quantity.toLocaleString()}</span>
            </div>
          </div>
        )),
      width: "14%",
    },
    {
      title: "Total Amount",
      render: (record) => (
        Number(record?.total_amount.toFixed(2)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      ),
      width: "8%",
    },
    {
      title: "PO Date",
      render: (record) => record.po_date,
      width: "8%",
    },
    {
      title: "Delivery Date",
      render: (record) => record.po_date,
      width: "8%",
    },
    {
      title: "Initiated By",
      render: (record) => record?.initiated_by_name,
      width: "10%",
    },
    {
      title: "Remarks",
      render: (record) => record?.remarks,
      width: "10%",
    },

    {
      title: "Action",
      width: "5%",
      render: (record) => {
        return (
          <React.Fragment>
            <div className="d-flex">
              <Tooltip title="View">
                <Button
                  className="d-flex align-items-center"
                  onClick={() => handlePoModalVisibility(record)}
                >
                  <EyeOutlined />
                </Button>
              </Tooltip>
            </div>
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <>
      {visibility && (
        <POTemplate
          visible={visibility}
          modalClose={handlePoModalClose}
          data={selectedPoData}
        />
      )}
      <div className="farmerDashboard">
        <div className="shadow-sm p-3">
          <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
            <div>
              <Select
                placeholder="Select Supplier"
                className="me-3"
                onChange={handleSupplier}
                style={{ width: "200px" }}
              >
                <Option value="">All Suppliers</Option>
                {supplierList?.map((supplier) => (
                  <Option
                    value={supplier?.supplier_id}
                    key={supplier?.supplier_id}
                  >
                    {supplier?.supplier_name}
                  </Option>
                ))}
              </Select>

              <RangePicker
                onChange={handlePODateRage}
                value={
                  selectedDateRange
                    ? selectedDateRange.map((date) => dayjs(date))
                    : null
                }
                style={{ width: "250px" }}
              />
            </div>
          </div>
          {poList.length > 0 ? (
            <Table
              className="border"
              size="small"
              columns={poColumn}
              dataSource={poList}
              loading={poLoading}
              rowKey={(record) => record?.po_id}
              pagination={{
                current: currentPage,
                pageSize: 10,
                total: totalItems,
                onChange: handlePageChange,
              }}
            />
          ) : (
            <div
              className="d-flex shadow-sm flex-column justify-content-center align-items-center"
              style={{ height: "300px", backgroundColor: "white" }}
            >
              <FilterAltOutlinedIcon
                style={{ fontSize: 40, color: "#003608" }}
              />
              <h5>No Data To Display</h5>
              <p>
                Your Purchase Order Report will be shown here when data is
                available.
              </p>
              <div></div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
